import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useApi, errMsg } from "@/lib/api";

export const AdminUsers = () => {
  const api = useApi();
  const [data, setData] = useState({ roles: [], users: [] });
  const load = useCallback(() => api("get", "/users").then(setData).catch(() => {}), [api]);
  useEffect(() => { load(); }, [load]);

  const change = async (u, role) => {
    try { await api("patch", `/users/${u.user_id}/role`, { role }); toast.success("Role updated"); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="rounded-2xl border border-slate-200 bg-white" data-testid="admin-users-list">
      <p className="border-b border-slate-100 p-4 text-sm text-slate-500">People who have signed in. Give "admin" to staff who should manage bookings.</p>
      {data.users.map((u) => (
        <div key={u.user_id} className="flex items-center justify-between gap-4 border-b border-slate-100 p-4 last:border-0" data-testid="admin-user-row">
          <div><p className="font-semibold text-slate-800">{u.name || u.email || u.user_id}</p><p className="text-xs text-slate-500">{u.email}</p></div>
          <Select value={u.role} onValueChange={(r) => change(u, r)}>
            <SelectTrigger className="w-32" data-testid="admin-user-role-select"><SelectValue /></SelectTrigger>
            <SelectContent>{data.roles.map((r) => <SelectItem key={r} value={r} className="capitalize">{r}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      ))}
    </div>
  );
};
